module.exports = "../images/pano-background-wall-3.jpg";